import { graphql } from '../gql'

/**
 * GraphQL operations for the Signature feature (CRE-17).
 */

/** Query: Get order data for signature collection. */
export const GetOrderDataForSignature = graphql(`
	query GetOrderDataForSignature($orderId: Int!) {
		order(id: $orderId) {
			id
			customer {
				id
			}
			contacts {
				id
				default
				contact {
					id
					firstName
					lastName
				}
				role {
					name
					slug
					sort
				}
			}
			terms {
				id
				accepted
				needsAcceptance
				content {
					id
					title
					body
					format
				}
			}
		}
	}
`)

/** Query: Get customer contacts for signature picker. */
export const GetCustomerContacts = graphql(`
	query GetCustomerContacts($customerId: Int!) {
		customers(where: { id: { equals: $customerId } }) {
			id
			contacts(where: { active: { equals: true } }) {
				id
				firstName
				lastName
			}
		}
	}
`)

/** Query: Get work ticket data for signature modal. */
export const GetWorkTicketDataForSignature = graphql(`
	query GetWorkTicketDataForSignature($orderId: Int!) {
		order(id: $orderId) {
			id
			customer {
				id
			}
			contacts {
				id
				default
				contact {
					id
					firstName
					lastName
				}
				role {
					name
					slug
					sort
				}
			}
			terms {
				id
				accepted
				needsAcceptance
				content {
					id
					title
					body
					format
				}
			}
			dateOfServiceLocal
			status
			statusDetails {
				slug
				name
			}
			branchId
			site {
				id
				address {
					id
					timezone
				}
			}
			signature {
				id
				metadata {
					key
					value
				}
			}
			assignments {
				id
				roleDetails {
					slug
					sort
				}
				operator {
					id
					firstName
					lastName
				}
			}
			planned {
				id
				equipment {
					id
					name
					displayName
				}
				inventory {
					id
					quantity
					item {
						id
						name
						category
						displayUnit
						visibility {
							operatorWorkTicket
							customerWorkTicket
						}
					}
				}
				schedule {
					id
					scheduleIndex
					startTime
					endTime
					step
					stepDetails {
						slug
						name
					}
					metrics {
						key
						value
					}
				}
			}
			billable {
				equipment {
					id
					name
					displayName
				}
			}
			actuals {
				id
				subType
				inventory {
					id
					quantity
					item {
						id
						name
						category
						displayUnit
						visibility {
							operatorWorkTicket
							customerWorkTicket
						}
					}
				}
				schedule {
					id
					scheduleIndex
					startTime
					endTime
					step
					stepDetails {
						slug
						name
					}
					metrics {
						key
						value
					}
				}
			}
		}
	}
`)

/** Mutation: Collect customer signature on an order. */
export const CollectOrderSignature = graphql(`
	mutation CollectOrderSignature(
		$data: CollectSignatureInput!
		$where: OrderWhereUniqueInput!
	) {
		collectOrderSignature(data: $data, where: $where) {
			id
		}
	}
`)
